import {
  differenceInCalendarDays,
  differenceInHours,
  differenceInSeconds,
} from "date-fns";

export function getRemainingTime(time: Date) {
  if (!time) return "";

  const remainingTime = differenceInSeconds(time, new Date());
  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export const getRemainingSeconds = (time: Date) => {
  const remainingTime = differenceInSeconds(time, new Date());
  return remainingTime;
};

export const getRemainingMinutes = (time: Date) => {
  const remainingTime = differenceInSeconds(time, new Date());
  return Math.floor(remainingTime / 60);
};

export function getRemainingHours(time: Date) {
  return differenceInHours(time, new Date());
}

export const getFullRemainingTime = (time: Date) => {
  const remainingTime = differenceInSeconds(time, new Date());
  const days = Math.floor(remainingTime / 86400);
  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  const seconds = remainingTime % 60;

  return {
    days: days > 0 ? days : 0,
    hours: hours > 0 ? hours : 0,
    minutes: minutes > 0 ? minutes : 0,
    seconds: seconds > 0 ? seconds : 0,
  };
};

export function getRemainingDays(time: Date) {
  return differenceInCalendarDays(time, new Date());
}

export function getDaysSince(time: Date) {
  return differenceInCalendarDays(new Date(), time);
}
